var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7164_39428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 10H11M2.5 2H9.5C10.0523 2 10.5 2.44772 10.5 3V8C10.5 8.55228 10.0523 9 9.5 9H2.5C1.94772 9 1.5 8.55228 1.5 8V3C1.5 2.44772 1.94772 2 2.5 2Z",
    stroke: "#525062",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 6.59031L6.2 7.03176C6.2394 7.07524 6.28617 7.10973 6.33764 7.13327C6.38912 7.1568 6.44428 7.16891 6.5 7.16891C6.55572 7.16891 6.61088 7.1568 6.66236 7.13327C6.71383 7.10973 6.7606 7.07524 6.8 7.03176C6.8394 6.98828 6.87065 6.93667 6.89197 6.87986C6.91329 6.82305 6.92426 6.76216 6.92426 6.70067C6.92426 6.63918 6.91329 6.57829 6.89197 6.52149C6.87065 6.46468 6.8394 6.41306 6.8 6.36958M6.4 5.92812L6.9 6.47994C6.97956 6.56775 7.08748 6.61709 7.2 6.61709C7.31252 6.61709 7.42044 6.56775 7.5 6.47994C7.57957 6.39213 7.62426 6.27303 7.62426 6.14885C7.62426 6.02467 7.57957 5.90557 7.5 5.81776L6.724 4.96133C6.6115 4.83733 6.459 4.76767 6.3 4.76767C6.141 4.76767 5.9885 4.83733 5.876 4.96133L5.7 5.15557C5.62044 5.24338 5.51252 5.29272 5.4 5.29272C5.28748 5.29272 5.17956 5.24338 5.1 5.15557C5.02044 5.06776 4.97574 4.94866 4.97574 4.82448C4.97574 4.7003 5.02044 4.5812 5.1 4.49339L5.662 3.87314C5.84445 3.67231 6.08238 3.54438 6.33813 3.5096C6.59388 3.47481 6.85283 3.53517 7.074 3.68111L7.168 3.74291C7.25316 3.79964 7.35441 3.81931 7.452 3.79809L7.8 3.72084M7.8 3.50011L8 5.92812H7.6M4.2 3.50011L4 5.92812L5.3 7.36286C5.37956 7.45067 5.48748 7.5 5.6 7.5C5.71252 7.5 5.82044 7.45067 5.9 7.36286C5.97956 7.27505 6.02426 7.15595 6.02426 7.03176C6.02426 6.90758 5.97956 6.78848 5.9 6.70067M4.2 3.72084H5.8",
    stroke: "#525062",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7164_39428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpGrey);
export default __webpack_public_path__ + "static/media/vpGrey.ca98ecce3c9a62d43305bde27e85b8e7.svg";
export { ForwardRef as ReactComponent };